// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules (App)
import { SharedModule } from '@shared/shared.module';
import { RecaptchaModule } from '@shared/recaptcha-v2/recaptcha.module';
import { AccordionModule } from 'primeng/accordion';

// Services (PrimeNg)
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';

// Modules (PrimeNg)
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { PanelModule } from 'primeng/panel';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { GetStartedComponent } from './home/get-started/get-started.component';

// Components
import { HomeComponent } from './home/home.component';
import { AccountComponent } from './home/select-account/account/account.component';
import { SelectAccountComponent } from './home/select-account/select-account.component';
import { ValidateTaxModalComponent } from './home/select-account/validate-tax-modal/validate-tax-modal.component';
import { UserInfoComponent } from './home/user-info/user-info.component';

@NgModule({
  imports: [
    // Angular
    FormsModule,
    ReactiveFormsModule,
    CommonModule,

    // PrimeNg
    AccordionModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    DatePickerModule,
    DialogModule,
    InputMaskModule,
    InputTextModule,
    ListboxModule,
    MenuModule,
    MessageModule,
    PanelModule,
    PickListModule,
    PopoverModule,
    ProgressSpinnerModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    SelectModule,
    StepperModule,
    TableModule,
    TabsModule,
    ToastModule,
    ToggleButtonModule,
    TooltipModule,

    // App
    SharedModule,
    CardModule,
    RecaptchaModule
  ],
  declarations: [
    HomeComponent,
    GetStartedComponent,
    UserInfoComponent,
    SelectAccountComponent,
    AccountComponent,
    ValidateTaxModalComponent
  ],
  providers: [
    // PrimeNg
    ConfirmationService,
    MessageService
  ],
  exports: [HomeComponent]
})
export class FeatureModule {}
